module.exports = __webpack_public_path__ + "static/box-04-min-61be6b20adc0893a8d291b808097dffc.png";